export const AssetHelper = {
    images: {
        placeholder: "/dist/assets/images/noImage.png"
    }
};